export const environment = {
  production: true,
  apiUrl: '/basedata',
  hubUrl: '/core/ChangeNotificationHub',
  defaultLanguage: 'en',
  isMachinePhaseVisible: true,
  coreApiUrl: '/core',
  signalrBaseUrl: '/core/ChangeNotificationHub',
  liveApiUrl: '/live',
  pandaApiUrl: '/panda',
  basedataApiUrl: '/basedata'
};
